export default __webpack_public_path__ + "static/media/gallery-wps-5.255092c8.jpg";